module.exports = __webpack_public_path__ + "img/yll_title.afea9036.png";